// source: witbooking/backoffice/inventory/v1/inventory_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryAccommodation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryLine', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryLineError', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryLineErrorCode', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryLineValueType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryMealPlan', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.InventoryState', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.OpenDateRange', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.ParametrizedFormula', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.RackRateValue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.RackRateValue.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.RateValue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.RateValue.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.displayName = 'proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.displayName = 'proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.displayName = 'proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.displayName = 'proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.inventory.v1.InventoryLineError.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.InventoryLineError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.InventoryLineError.displayName = 'proto.witbooking.backoffice.inventory.v1.InventoryLineError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.displayName = 'proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.displayName = 'proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.InventoryLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.InventoryLine.displayName = 'proto.witbooking.backoffice.inventory.v1.InventoryLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.InventoryCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.InventoryCondition.displayName = 'proto.witbooking.backoffice.inventory.v1.InventoryCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.InventoryMealPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.displayName = 'proto.witbooking.backoffice.inventory.v1.InventoryMealPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.InventoryAccommodation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.displayName = 'proto.witbooking.backoffice.inventory.v1.InventoryAccommodation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.InventoryConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.displayName = 'proto.witbooking.backoffice.inventory.v1.InventoryConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.OpenDateRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.OpenDateRange.displayName = 'proto.witbooking.backoffice.inventory.v1.OpenDateRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.InventoryState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.inventory.v1.InventoryState.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.InventoryState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.InventoryState.displayName = 'proto.witbooking.backoffice.inventory.v1.InventoryState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.displayName = 'proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.displayName = 'proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.displayName = 'proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.displayName = 'proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.displayName = 'proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.displayName = 'proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.RackRateValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.RackRateValue.displayName = 'proto.witbooking.backoffice.inventory.v1.RackRateValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.RateValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.RateValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.RateValue.displayName = 'proto.witbooking.backoffice.inventory.v1.RateValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.ParametrizedFormula, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.displayName = 'proto.witbooking.backoffice.inventory.v1.ParametrizedFormula';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.displayName = 'proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.displayName = 'proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest;
  return proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoriesList: jspb.Message.toObjectList(msg.getInventoriesList(),
    proto.witbooking.backoffice.inventory.v1.InventoryState.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse;
  return proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryState;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryState.deserializeBinaryFromReader);
      msg.addInventories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryState.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InventoryState inventories = 1;
 * @return {!Array<!proto.witbooking.backoffice.inventory.v1.InventoryState>}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.prototype.getInventoriesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.inventory.v1.InventoryState>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryState, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.inventory.v1.InventoryState>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse} returns this
*/
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.prototype.setInventoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryState=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.prototype.addInventories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.inventory.v1.InventoryState, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.prototype.clearInventoriesList = function() {
  return this.setInventoriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.repeatedFields_ = [1,2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    configurationsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    mealPlansList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    conditionsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest;
  return proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccommodations(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addConfigurations(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addMealPlans(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addConditions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getConfigurationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getMealPlansList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getConditionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * repeated string accommodations = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.getAccommodationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.setAccommodationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.addAccommodations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.clearAccommodationsList = function() {
  return this.setAccommodationsList([]);
};


/**
 * repeated string configurations = 2;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.getConfigurationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.setConfigurationsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.addConfigurations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.clearConfigurationsList = function() {
  return this.setConfigurationsList([]);
};


/**
 * repeated string meal_plans = 3;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.getMealPlansList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.setMealPlansList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.addMealPlans = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.clearMealPlansList = function() {
  return this.setMealPlansList([]);
};


/**
 * repeated string conditions = 4;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.getConditionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.setConditionsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.addConditions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest.prototype.clearConditionsList = function() {
  return this.setConditionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    createdInventories: jspb.Message.getFieldWithDefault(msg, 1, 0),
    errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.witbooking.backoffice.inventory.v1.InventoryLineError.toObject, includeInstance),
    createdTickersList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse;
  return proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedInventories(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryLineError;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryLineError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCreatedTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedInventories();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryLineError.serializeBinaryToWriter
    );
  }
  f = message.getCreatedTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional int32 created_inventories = 1;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.getCreatedInventories = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.setCreatedInventories = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated InventoryLineError errors = 2;
 * @return {!Array<!proto.witbooking.backoffice.inventory.v1.InventoryLineError>}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.inventory.v1.InventoryLineError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryLineError, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.inventory.v1.InventoryLineError>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} returns this
*/
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLineError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.inventory.v1.InventoryLineError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};


/**
 * repeated string created_tickers = 3;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.getCreatedTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.setCreatedTickersList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.addCreatedTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.prototype.clearCreatedTickersList = function() {
  return this.setCreatedTickersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.InventoryLineError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    relatedTickersList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    valueType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    errorCode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.InventoryLineError;
  return proto.witbooking.backoffice.inventory.v1.InventoryLineError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRelatedTickers(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.inventory.v1.InventoryLineValueType} */ (reader.readEnum());
      msg.setValueType(value);
      break;
    case 4:
      var value = /** @type {!proto.witbooking.backoffice.inventory.v1.InventoryLineErrorCode} */ (reader.readEnum());
      msg.setErrorCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.InventoryLineError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRelatedTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getValueType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getErrorCode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string related_tickers = 2;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.getRelatedTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.setRelatedTickersList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.addRelatedTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.clearRelatedTickersList = function() {
  return this.setRelatedTickersList([]);
};


/**
 * optional InventoryLineValueType value_type = 3;
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineValueType}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.getValueType = function() {
  return /** @type {!proto.witbooking.backoffice.inventory.v1.InventoryLineValueType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLineValueType} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.setValueType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional InventoryLineErrorCode error_code = 4;
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineErrorCode}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.getErrorCode = function() {
  return /** @type {!proto.witbooking.backoffice.inventory.v1.InventoryLineErrorCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLineErrorCode} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string error_message = 5;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLineError} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineError.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    onlyValidLines: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    locale: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest;
  return proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnlyValidLines(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnlyValidLines();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool only_valid_lines = 1;
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.prototype.getOnlyValidLines = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.prototype.setOnlyValidLines = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string locale = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryLinesList: jspb.Message.toObjectList(msg.getInventoryLinesList(),
    proto.witbooking.backoffice.inventory.v1.InventoryLine.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse;
  return proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryLine;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryLine.deserializeBinaryFromReader);
      msg.addInventoryLines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryLine.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InventoryLine inventory_lines = 1;
 * @return {!Array<!proto.witbooking.backoffice.inventory.v1.InventoryLine>}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.prototype.getInventoryLinesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.inventory.v1.InventoryLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryLine, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.inventory.v1.InventoryLine>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse} returns this
*/
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.prototype.setInventoryLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine}
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.prototype.addInventoryLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.inventory.v1.InventoryLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.prototype.clearInventoryLinesList = function() {
  return this.setInventoryLinesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.InventoryLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.toObject = function(includeInstance, msg) {
  var f, obj = {
    legacyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    code: jspb.Message.getFieldWithDefault(msg, 2, ""),
    blockingType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    condition: (f = msg.getCondition()) && proto.witbooking.backoffice.inventory.v1.InventoryCondition.toObject(includeInstance, f),
    mealPlan: (f = msg.getMealPlan()) && proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.toObject(includeInstance, f),
    accommodation: (f = msg.getAccommodation()) && proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.toObject(includeInstance, f),
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.InventoryLine;
  return proto.witbooking.backoffice.inventory.v1.InventoryLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegacyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlockingType(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryCondition;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryCondition.deserializeBinaryFromReader);
      msg.setCondition(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryMealPlan;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.deserializeBinaryFromReader);
      msg.setMealPlan(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryAccommodation;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.deserializeBinaryFromReader);
      msg.setAccommodation(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.InventoryLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegacyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBlockingType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCondition();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryCondition.serializeBinaryToWriter
    );
  }
  f = message.getMealPlan();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.serializeBinaryToWriter
    );
  }
  f = message.getAccommodation();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.serializeBinaryToWriter
    );
  }
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 legacy_id = 1;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.getLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.setLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string blocking_type = 3;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.getBlockingType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.setBlockingType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional InventoryCondition condition = 4;
 * @return {?proto.witbooking.backoffice.inventory.v1.InventoryCondition}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.getCondition = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.InventoryCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryCondition, 4));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.InventoryCondition|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.setCondition = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.clearCondition = function() {
  return this.setCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.hasCondition = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional InventoryMealPlan meal_plan = 5;
 * @return {?proto.witbooking.backoffice.inventory.v1.InventoryMealPlan}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.getMealPlan = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.InventoryMealPlan} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryMealPlan, 5));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.InventoryMealPlan|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.setMealPlan = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.clearMealPlan = function() {
  return this.setMealPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.hasMealPlan = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional InventoryAccommodation accommodation = 6;
 * @return {?proto.witbooking.backoffice.inventory.v1.InventoryAccommodation}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.getAccommodation = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.InventoryAccommodation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryAccommodation, 6));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.InventoryAccommodation|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.setAccommodation = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.clearAccommodation = function() {
  return this.setAccommodation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.hasAccommodation = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional InventoryConfiguration configuration = 7;
 * @return {?proto.witbooking.backoffice.inventory.v1.InventoryConfiguration}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryConfiguration, 7));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.InventoryConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryLine} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLine.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.InventoryCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryCondition}
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.InventoryCondition;
  return proto.witbooking.backoffice.inventory.v1.InventoryCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryCondition}
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.InventoryCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryCondition} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryCondition} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryCondition.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryMealPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryMealPlan}
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.InventoryMealPlan;
  return proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryMealPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryMealPlan}
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryMealPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryMealPlan} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryMealPlan} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryMealPlan.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryAccommodation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryAccommodation}
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.InventoryAccommodation;
  return proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryAccommodation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryAccommodation}
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryAccommodation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryAccommodation} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryAccommodation} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryAccommodation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    adult: jspb.Message.getFieldWithDefault(msg, 3, 0),
    baby: jspb.Message.getFieldWithDefault(msg, 4, 0),
    child: jspb.Message.getFieldWithDefault(msg, 5, 0),
    teenager: jspb.Message.getFieldWithDefault(msg, 6, 0),
    senior: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.InventoryConfiguration;
  return proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdult(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBaby(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChild(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeenager(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSenior(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdult();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBaby();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getChild();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTeenager();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSenior();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 adult = 3;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.getAdult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.setAdult = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 baby = 4;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.getBaby = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.setBaby = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 child = 5;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.getChild = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.setChild = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 teenager = 6;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.getTeenager = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.setTeenager = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 senior = 7;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.getSenior = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryConfiguration} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryConfiguration.prototype.setSenior = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.OpenDateRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.OpenDateRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.OpenDateRange}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.OpenDateRange;
  return proto.witbooking.backoffice.inventory.v1.OpenDateRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.OpenDateRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.OpenDateRange}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.OpenDateRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.OpenDateRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.OpenDateRange} returns this
*/
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.OpenDateRange} returns this
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.OpenDateRange} returns this
*/
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.OpenDateRange} returns this
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.OpenDateRange.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.repeatedFields_ = [14,15,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.InventoryState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accommodation: jspb.Message.getFieldWithDefault(msg, 3, ""),
    configuration: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mealPlan: jspb.Message.getFieldWithDefault(msg, 5, ""),
    condition: jspb.Message.getFieldWithDefault(msg, 6, ""),
    rate: (f = msg.getRate()) && proto.witbooking.backoffice.inventory.v1.RateValue.toObject(includeInstance, f),
    availability: (f = msg.getAvailability()) && proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.toObject(includeInstance, f),
    lock: (f = msg.getLock()) && proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.toObject(includeInstance, f),
    minStay: (f = msg.getMinStay()) && proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.toObject(includeInstance, f),
    maxStay: (f = msg.getMaxStay()) && proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.toObject(includeInstance, f),
    minNotice: (f = msg.getMinNotice()) && proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.toObject(includeInstance, f),
    maxNotice: (f = msg.getMaxNotice()) && proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.toObject(includeInstance, f),
    codesList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    checkinDaysList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
    checkoutDaysList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    bookingWindowPeriod: (f = msg.getBookingWindowPeriod()) && proto.witbooking.backoffice.inventory.v1.OpenDateRange.toObject(includeInstance, f),
    rackRate: (f = msg.getRackRate()) && proto.witbooking.backoffice.inventory.v1.RackRateValue.toObject(includeInstance, f),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    closeToArrival: (f = msg.getCloseToArrival()) && proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.toObject(includeInstance, f),
    closeToDeparture: (f = msg.getCloseToDeparture()) && proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.InventoryState;
  return proto.witbooking.backoffice.inventory.v1.InventoryState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccommodation(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfiguration(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMealPlan(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCondition(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.inventory.v1.RateValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.RateValue.deserializeBinaryFromReader);
      msg.setRate(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setAvailability(value);
      break;
    case 9:
      var value = new proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setLock(value);
      break;
    case 10:
      var value = new proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setMinStay(value);
      break;
    case 11:
      var value = new proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setMaxStay(value);
      break;
    case 12:
      var value = new proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setMinNotice(value);
      break;
    case 13:
      var value = new proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setMaxNotice(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addCodes(value);
      break;
    case 15:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setCheckinDaysList(value);
      break;
    case 16:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setCheckoutDaysList(value);
      break;
    case 17:
      var value = new proto.witbooking.backoffice.inventory.v1.OpenDateRange;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.OpenDateRange.deserializeBinaryFromReader);
      msg.setBookingWindowPeriod(value);
      break;
    case 18:
      var value = new proto.witbooking.backoffice.inventory.v1.RackRateValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.RackRateValue.deserializeBinaryFromReader);
      msg.setRackRate(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 20:
      var value = new proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setCloseToArrival(value);
      break;
    case 21:
      var value = new proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.deserializeBinaryFromReader);
      msg.setCloseToDeparture(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.InventoryState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.InventoryState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccommodation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConfiguration();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMealPlan();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCondition();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.inventory.v1.RateValue.serializeBinaryToWriter
    );
  }
  f = message.getAvailability();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.serializeBinaryToWriter
    );
  }
  f = message.getLock();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.serializeBinaryToWriter
    );
  }
  f = message.getMinStay();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxStay();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.serializeBinaryToWriter
    );
  }
  f = message.getMinNotice();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxNotice();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.serializeBinaryToWriter
    );
  }
  f = message.getCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getCheckinDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      15,
      f
    );
  }
  f = message.getCheckoutDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      16,
      f
    );
  }
  f = message.getBookingWindowPeriod();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.witbooking.backoffice.inventory.v1.OpenDateRange.serializeBinaryToWriter
    );
  }
  f = message.getRackRate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.witbooking.backoffice.inventory.v1.RackRateValue.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getCloseToArrival();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseToDeparture();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string accommodation = 3;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getAccommodation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setAccommodation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string configuration = 4;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getConfiguration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setConfiguration = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string meal_plan = 5;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getMealPlan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setMealPlan = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string condition = 6;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional RateValue rate = 7;
 * @return {?proto.witbooking.backoffice.inventory.v1.RateValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getRate = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.RateValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.RateValue, 7));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.RateValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setRate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearRate = function() {
  return this.setRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasRate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SharedOwnUnionValue availability = 8;
 * @return {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getAvailability = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue, 8));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setAvailability = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearAvailability = function() {
  return this.setAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasAvailability = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SharedOwnUnionValue lock = 9;
 * @return {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getLock = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue, 9));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setLock = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearLock = function() {
  return this.setLock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasLock = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ConstantSharedOwnUnionValue min_stay = 10;
 * @return {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getMinStay = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue, 10));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setMinStay = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearMinStay = function() {
  return this.setMinStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasMinStay = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional ConstantSharedOwnUnionValue max_stay = 11;
 * @return {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getMaxStay = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue, 11));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setMaxStay = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearMaxStay = function() {
  return this.setMaxStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasMaxStay = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ConstantSharedOwnUnionValue min_notice = 12;
 * @return {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getMinNotice = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue, 12));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setMinNotice = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearMinNotice = function() {
  return this.setMinNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasMinNotice = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ConstantSharedOwnUnionValue max_notice = 13;
 * @return {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getMaxNotice = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue, 13));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setMaxNotice = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearMaxNotice = function() {
  return this.setMaxNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasMaxNotice = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated string codes = 14;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setCodesList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.addCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearCodesList = function() {
  return this.setCodesList([]);
};


/**
 * repeated witbooking.backoffice.common.DayOfWeek checkin_days = 15;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getCheckinDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setCheckinDaysList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.addCheckinDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearCheckinDaysList = function() {
  return this.setCheckinDaysList([]);
};


/**
 * repeated witbooking.backoffice.common.DayOfWeek checkout_days = 16;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getCheckoutDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setCheckoutDaysList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.addCheckoutDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearCheckoutDaysList = function() {
  return this.setCheckoutDaysList([]);
};


/**
 * optional OpenDateRange booking_window_period = 17;
 * @return {?proto.witbooking.backoffice.inventory.v1.OpenDateRange}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getBookingWindowPeriod = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.OpenDateRange} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.OpenDateRange, 17));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.OpenDateRange|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setBookingWindowPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearBookingWindowPeriod = function() {
  return this.setBookingWindowPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasBookingWindowPeriod = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional RackRateValue rack_rate = 18;
 * @return {?proto.witbooking.backoffice.inventory.v1.RackRateValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getRackRate = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.RackRateValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.RackRateValue, 18));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.RackRateValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setRackRate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearRackRate = function() {
  return this.setRackRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasRackRate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool active = 19;
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional SharedOwnUnionValue close_to_arrival = 20;
 * @return {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getCloseToArrival = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue, 20));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setCloseToArrival = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearCloseToArrival = function() {
  return this.setCloseToArrival(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasCloseToArrival = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional SharedOwnUnionValue close_to_departure = 21;
 * @return {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.getCloseToDeparture = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue, 21));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
*/
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.setCloseToDeparture = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.InventoryState} returns this
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.clearCloseToDeparture = function() {
  return this.setCloseToDeparture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.InventoryState.prototype.hasCloseToDeparture = function() {
  return jspb.Message.getField(this, 21) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryState: (f = msg.getInventoryState()) && proto.witbooking.backoffice.inventory.v1.InventoryState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest;
  return proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryState;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryState.deserializeBinaryFromReader);
      msg.setInventoryState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryState();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryState.serializeBinaryToWriter
    );
  }
};


/**
 * optional InventoryState inventory_state = 1;
 * @return {?proto.witbooking.backoffice.inventory.v1.InventoryState}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.prototype.getInventoryState = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.InventoryState} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryState, 1));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.InventoryState|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} returns this
*/
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.prototype.setInventoryState = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.prototype.clearInventoryState = function() {
  return this.setInventoryState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest.prototype.hasInventoryState = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse;
  return proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryState: (f = msg.getInventoryState()) && proto.witbooking.backoffice.inventory.v1.InventoryState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest;
  return proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryState;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryState.deserializeBinaryFromReader);
      msg.setInventoryState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryState();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryState.serializeBinaryToWriter
    );
  }
};


/**
 * optional InventoryState inventory_state = 1;
 * @return {?proto.witbooking.backoffice.inventory.v1.InventoryState}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.prototype.getInventoryState = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.InventoryState} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryState, 1));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.InventoryState|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} returns this
*/
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.prototype.setInventoryState = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.prototype.clearInventoryState = function() {
  return this.setInventoryState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest.prototype.hasInventoryState = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: (f = msg.getError()) && proto.witbooking.backoffice.inventory.v1.InventoryLineError.toObject(includeInstance, f),
    createdTicker: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse;
  return proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.inventory.v1.InventoryLineError;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.InventoryLineError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.inventory.v1.InventoryLineError.serializeBinaryToWriter
    );
  }
  f = message.getCreatedTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional InventoryLineError error = 1;
 * @return {?proto.witbooking.backoffice.inventory.v1.InventoryLineError}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.getError = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.InventoryLineError} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.InventoryLineError, 1));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.InventoryLineError|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse} returns this
*/
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string created_ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.getCreatedTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse} returns this
 */
proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.prototype.setCreatedTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.ValueCase = {
  VALUE_NOT_SET: 0,
  PARENT_TICKER: 1,
  OWN: 2
};

/**
 * @return {proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.ValueCase}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    own: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue;
  return proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string parent_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string own = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.getOwn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.setOwn = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.clearOwn = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.SharedOwnUnionValue.prototype.hasOwn = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.ValueCase = {
  VALUE_NOT_SET: 0,
  PARENT_TICKER: 1,
  CONSTANT: 2,
  OWN: 3
};

/**
 * @return {proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.ValueCase}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    constant: (f = msg.getConstant()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    own: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue;
  return proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string parent_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int64Value constant = 2;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.getConstant = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} returns this
*/
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string own = 3;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.getOwn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.setOwn = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.clearOwn = function() {
  return jspb.Message.setOneofField(this, 3, proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.ConstantSharedOwnUnionValue.prototype.hasOwn = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.ValueCase = {
  VALUE_NOT_SET: 0,
  PARENT_TICKER: 1,
  CONSTANT: 2,
  OWN: 3
};

/**
 * @return {proto.witbooking.backoffice.inventory.v1.RackRateValue.ValueCase}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.inventory.v1.RackRateValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.RackRateValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.RackRateValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    constant: (f = msg.getConstant()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    own: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.RackRateValue;
  return proto.witbooking.backoffice.inventory.v1.RackRateValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.RackRateValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.RackRateValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.RackRateValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string parent_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.DoubleValue constant = 2;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.getConstant = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 2));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue} returns this
*/
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string own = 3;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.getOwn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.setOwn = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.RackRateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.clearOwn = function() {
  return jspb.Message.setOneofField(this, 3, proto.witbooking.backoffice.inventory.v1.RackRateValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.RackRateValue.prototype.hasOwn = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.ValueCase = {
  VALUE_NOT_SET: 0,
  PARENT_TICKER: 1,
  FORMULA: 2,
  OWN: 3,
  PARAMETRIZED_FORMULA: 4
};

/**
 * @return {proto.witbooking.backoffice.inventory.v1.RateValue.ValueCase}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.inventory.v1.RateValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.RateValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.RateValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.RateValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    formula: jspb.Message.getFieldWithDefault(msg, 2, ""),
    own: jspb.Message.getFieldWithDefault(msg, 3, ""),
    parametrizedFormula: (f = msg.getParametrizedFormula()) && proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.RateValue;
  return proto.witbooking.backoffice.inventory.v1.RateValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.RateValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormula(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwn(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.inventory.v1.ParametrizedFormula;
      reader.readMessage(value,proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.deserializeBinaryFromReader);
      msg.setParametrizedFormula(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.RateValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.RateValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.RateValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getParametrizedFormula();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.serializeBinaryToWriter
    );
  }
};


/**
 * optional string parent_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string formula = 2;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.getFormula = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.setFormula = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.clearFormula = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.hasFormula = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string own = 3;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.getOwn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.setOwn = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.clearOwn = function() {
  return jspb.Message.setOneofField(this, 3, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.hasOwn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ParametrizedFormula parametrized_formula = 4;
 * @return {?proto.witbooking.backoffice.inventory.v1.ParametrizedFormula}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.getParametrizedFormula = function() {
  return /** @type{?proto.witbooking.backoffice.inventory.v1.ParametrizedFormula} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.inventory.v1.ParametrizedFormula, 4));
};


/**
 * @param {?proto.witbooking.backoffice.inventory.v1.ParametrizedFormula|undefined} value
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
*/
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.setParametrizedFormula = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.backoffice.inventory.v1.RateValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.inventory.v1.RateValue} returns this
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.clearParametrizedFormula = function() {
  return this.setParametrizedFormula(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.inventory.v1.RateValue.prototype.hasParametrizedFormula = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.ParametrizedFormula} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.toObject = function(includeInstance, msg) {
  var f, obj = {
    immutableFormula: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rateOwner: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.ParametrizedFormula}
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.ParametrizedFormula;
  return proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.ParametrizedFormula} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.ParametrizedFormula}
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setImmutableFormula(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRateOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.ParametrizedFormula} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImmutableFormula();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRateOwner();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string immutable_formula = 3;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.prototype.getImmutableFormula = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.ParametrizedFormula} returns this
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.prototype.setImmutableFormula = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string rate_owner = 4;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.prototype.getRateOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.ParametrizedFormula} returns this
 */
proto.witbooking.backoffice.inventory.v1.ParametrizedFormula.prototype.setRateOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inventoryTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest;
  return proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string inventory_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.prototype.getInventoryTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} returns this
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest.prototype.setInventoryTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse;
  return proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineErrorCode = {
  INVALID_RATE_FORMULA: 0,
  INVALID_VALUE: 1,
  INVALID_ACTIVE: 2,
  INVALID_BOOKING_WINDOW_RANGE: 3,
  INVALID_EMPTY_VALUE: 4,
  INVALID_ACTION: 5,
  INVALID_ROWS: 6,
  INVALID_RATE_FORMULA_REFERENCED_ARGUMENT: 7,
  INVALID_SHARED_REFERENCE: 8,
  INVALID_INVENTORY: 9,
  INVALID_DELETE: 10,
  INVALID_CREATE: 11,
  NO_CONFIGURED_LIMIT: 12,
  LIMIT_EXCEEDED: 13,
  INVENTORY_IN_BUNDLE: 14,
  INVENTORY_HAS_RECENT_BOOKINGS: 15
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.inventory.v1.InventoryLineValueType = {
  NONE: 0,
  MAX_NOTICE: 1,
  MIN_NOTICE: 2,
  MAX_STAY: 3,
  MIN_STAY: 4,
  LOCK: 5,
  AVAILABILITY: 6,
  RATE: 7,
  CHECKIN_DAYS: 8,
  CHECKOUT_DAYS: 9,
  BOOKING_WINDOW_START: 10,
  BOOKING_WINDOW_END: 11,
  CODES: 12,
  ACTIVE: 13,
  RACK_RATE: 14,
  BOOKING_WINDOW: 15,
  ACTION: 16,
  CLOSE_TO_ARRIVAL: 17,
  CLOSE_TO_DEPARTURE: 18
};

goog.object.extend(exports, proto.witbooking.backoffice.inventory.v1);
